<script>
    import appConfig from '@src/app.config'
	import Layout from '@layouts/newdefaultform'
	import PageHeader from '@components/page-header'
	import { authComputed } from '@state/helpers'	
	import listManage from '@components/list-manage'
	import Confirmation from '@components/confirmation'
	import Information from '@components/information'
	import Spinner from '@components/spinner'
	import { giftlistApi } from '@router/apiFiles/giftlistApi'
	import { creditApi } from '@router/apiFiles/creditApi'
	import { blacklistApi } from '@router/apiFiles/blacklistApi'
	import axios from 'axios'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Minhas listas',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout, PageHeader, listManage, Confirmation, Information, Spinner
        },
        data() {
            return {
                title: 'Minhas listas',
                items: [
                    {
                        text: 'LaVille',
                        href: '/',
                    },
                    {
                        text: 'Listas',
                        href: '/',
                    },
                    {
                        text: 'Mihas listas',
                        active: true,
                    },
                ],
				userLists: [
				],
				creditData: {
					availableCredit: '',
					id: '',
					giftCard: '',
				},
				storeCreditData: {
					availableCredit: '',
					available: false
				},				
				showConfirmation: false,
				showInformation: false,
				giftlistIdToDelete: '',
				showImportFile: false,
				file1: null,
				selectedGiftlist: '',
				isBusy:false,
            }
        },
        mounted() {
            this.fetchData()
        },
        methods: {
			...authComputed,
            async fetchData() {
				var self = this;
				giftlistApi
					.getMyGiftlists()
						.then(function(data) {
        					if (data.data.length == 0) return;
							var list = data.data;
							self.userLists = [];
        					for(var list_i = 0; list_i < list.length; list_i++) {
          						self.userLists.push({
									  image: require('@assets/images/users/avatar-9.jpg'),
									  text: list[list_i].type + ' ' + list[list_i].date,
									  name: list[list_i].memberName,
									  url: list[list_i].url,
									  id: list[list_i].id
								  }
								);
        					}
						})
				creditApi.getMyCreditAccount().then(function(data) {
					if (data == null) return;
					self.creditData = data;
				});
				
				creditApi.GetMyStoreCreditBalance().then(function(data) {
					if (data == null || data.availableCredit == 0) return;
					self.storeCreditData.availableCredit = data.availableCredit;
				}).catch(e => console.log(e));
				
			},
			deleteGiftlist(id) {
				this.giftlistIdToDelete = id;
				this.showConfirmation = true;
			},
			confirmDeleteGiftlist() {
				var self = this;
				giftlistApi.deleteGiftlist({ id: this.giftlistIdToDelete }).then(function(data){
					self.userLists.forEach((item, index) => {
						if (item.id == self.giftlistIdToDelete) self.userLists.splice(index, 1);
					});
					self.skuIdToDelete = '';
				});
				this.showConfirmation = false;
			},
			cancelDeleteGiftlist() {
				this.showConfirmation = false;
			},
			async downloadItem({ url, label }) {
				const response = await axios.get(url, { responseType: "blob" });
				const blob = new Blob([response.data], { type: "application/pdf" });
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = label;
				link.click();
				URL.revokeObjectURL(link.href);
			},
			startImportFile(selectedGiftlistId) {
				this.selectedGiftlist = selectedGiftlistId;
				this.showImportFile = true;
			},
			sendToBlacklist(selectedGiftlistId) {

				blacklistApi.blockCreditFromList({ id: selectedGiftlistId }).then(function(data){
					alert('ok');
				});

			},			
			sendToVerified(selectedGiftlistId) {

				blacklistApi.setUserFromListVerified({ id: selectedGiftlistId }).then(function(data){
					alert('ok');
				});
			
			},			
			importFile() {
				var self = this;
				if (this.file1) {
					this.showImportFile = false;
					console.log(this.file1);
					console.log(this.file1.blob);
					var fr = new FileReader();
					fr.onload = function(e) {
						var content = e.target.result;
						var lines = content.split('\n');
						self.processFile(lines);
					}
					fr.readAsText(this.file1, "UTF-8");
				}
			},
			async processFile(lines) {
				this.isBusy = true;
				var self = this;
				var toInsert = [];
				lines.forEach((line, index) => {
					if (line.length <= 10) {
						if (line.indexOf(',' != -1)) {
							var id = parseInt(line.split(',')[0]);
							if (id > 0) toInsert.push(id);
						}
						else {
							var id = parseInt(line)
							if (id > 0) toInsert.push();
						}
					}
				});
				if (toInsert.length > 0) {
					for (var igf = 0; igf < toInsert.length; igf++) {
						var id = toInsert[igf];
						let response = await giftlistApi.incrementProduct({ giftlistId: parseInt(self.selectedGiftlist), skuId: id.toString() }).then(function(data) { });
					}
					//toInsert.forEach(async (id, index) => {
					//});
					self.showInformation = true;
				}
				this.isBusy = false;
			},
			
        }
    }
</script>

<template>
	<Layout>
		<Spinner :loading="isBusy" />
		<PageHeader :title="title" :items="items" />

		<div class="row">			
			<div class="col-md-8 offset-md-2">
				<div class="card">
					<div class="card-header custom">
					</div>
					<div class="card-body pt-2 pb-2">


						<div class="row py-1 centered-flex">
							<div class="media p-3" hidden>
								<feather type="gift" class="align-self-center icon-dual icon-lg mr-4"></feather>
								<div class="media-body">
									<h4 class="mt-0 mb-0">{{creditData.availableCredit}}</h4>
									<span class="text-muted">Valor total recebido</span>
								</div>
							</div>
								
							<div class="media p-3" v-show="creditData.availableCredit.length > 0">
								<feather type="shopping-cart" class="align-self-center icon-dual icon-lg mr-4"></feather>
								<div class="media-body">
									<h4 class="mt-0 mb-0">{{creditData.availableCredit}}</h4>
									<span class="text-muted">Saldo disponível para resgate</span>
								</div>
							</div>

							<div class="media p-3" v-show="creditData.giftCard.length > 0">
								<feather type="credit-card" class="align-self-center icon-dual icon-lg mr-4"></feather>
								<div class="media-body">
									<h4 class="mt-0 mb-0">{{creditData.giftCard}}</h4>
									<span class="text-muted">Vale-presente para resgate</span>
								</div>
							</div>

						</div>

						<div class="row py-1 centered-flex">
								
							<div class="media p-3" v-show="storeCreditData.available == true">
								<feather type="shopping-cart" class="align-self-center icon-dual icon-lg mr-4"></feather>
								<div class="media-body">
									<h4 class="mt-0 mb-0">{{storeCreditData.availableCredit}}</h4>
									<span class="text-muted">Saldo disponível em Loja</span>
								</div>
							</div>

						</div>


						<div class="row py-1 centered-flex">
							<!--<b-button variant="primary" v-show="creditData.id.length > 0" @click="downloadItem({url: 'http://logistica.lavillecasa.com.br/CustomerCredit/Relatorio/' + creditData.id, label:'Relatorio.pdf'})"><i class="uil uil-file-download-alt"></i> Baixar extrato</b-button>-->
							<b-button variant="primary" v-show="creditData.id.length > 0" :href="'http://logistica.lavillecasa.com.br/CustomerCredit/Relatorio/' + creditData.id" target="_self"><i class="uil uil-file-download-alt"></i> Baixar extrato</b-button>
						</div>

						<div class="row py-1 mt-2 centered-flex" v-show="currentUser().role == '2'">
							<p>{{currentUser().email}}</p>
						</div>


						<h5 class="mb-4 header-title">Minhas listas</h5>
						
						<div v-for="list of userLists" v-bind:key="list.id">

							<div class="media mt-1 border-top pt-3">
								<img :src="`${list.image}`" class="avatar rounded-circle mr-3" alt="" />
								<div class="media-body">
									<h6 class="mt-1 mb-0 font-size-15"><b-link :href="'/lista/' + list.url">{{ list.name }}</b-link></h6>
									<h6 class="text-muted font-weight-normal mt-1 mb-3">{{ list.text }}</h6>
								</div>
								<b-dropdown variant="black" right toggle-class="arrow-none text-muted pr-0">
									<template v-slot:button-content>
										Gerenciamento
										<i class="uil uil-cog"></i>
									</template>
									<b-dropdown-item :v-if="currentUser().role == '2'" @click="startImportFile(list.id)">
										<i class="uil uil-file mr-2"></i>Importar arquivo
									</b-dropdown-item>
									<!--
									<b-dropdown-item :v-if="currentUser().role == '2'" @click="sendToBlacklist(list.id)">
										<i class="uil uil-times mr-2"></i>Enviar para blacklist (Fraude)
									</b-dropdown-item>
									-->
									<b-dropdown-item :v-if="currentUser().role == '2'" @click="sendToVerified(list.id)">
										<i class="uil uil-shield-check mr-2"></i>Marcar como usuário autêntico (Liberar compra antecipada)
									</b-dropdown-item>
									<b-dropdown-item :href="'/editarlista/' + list.url">
										<i class="uil uil-edit-alt mr-2"></i>Editar informações
									</b-dropdown-item>
									<b-dropdown-item :href="'/adicionarprodutos/' + list.url">
										<i class="uil uil-plus-circle mr-2"></i>Adicionar produtos
									</b-dropdown-item>
									<b-dropdown-item :href="'/vereeditarlista/' + list.url">
										<i class="uil uil-cart mr-2"></i>Alterar produtos e quantidades
									</b-dropdown-item>
									<b-dropdown-item :href="'/lista/' + list.url">
										<i class="uil uil-share-alt mr-2"></i>Ver como convidado
									</b-dropdown-item>
									<b-dropdown-item :href="'/presentes/' + list.url">
										<i class="uil uil-bill mr-2"></i>Ver presentes
									</b-dropdown-item>
									<b-dropdown-item :href="'/resgatarprodutos/' + list.url">
										<i class="uil uil-shopping-trolley mr-2"></i>Resgatar produtos
									</b-dropdown-item>
									<div class="dropdown-divider"></div>
									<b-dropdown-item href="javascript:void(0);" @click="deleteGiftlist(list.id)" variant="danger">
										<i class="uil uil-trash mr-2"></i>Excluir lista
									</b-dropdown-item>
								</b-dropdown>
							</div>

							<!--
							<listManage
								:image="list.image"
								:name="list.name"
								:text="list.text"
								:url="list.url" />
								-->

						</div>
					</div>
				</div>				
			</div>			
		</div>
		
					<b-modal v-model="showImportFile" title="Importar arquivo">
						<h6>Selecionar arquivo</h6>
						<b-form-file v-model="file1" accept=".txt" :state="Boolean(file1)" placeholder="Escolha um arquivo ou arraste até aqui" drop-placeholder="Arraste um arquivo até aqui"></b-form-file>
						<template v-slot:modal-footer>
							<b-button variant="light" @click="showImportFile = false">Cancelar</b-button>
							<b-button variant="primary" @click="importFile()" >Carregar</b-button>
						</template>
					</b-modal>

		<Confirmation confirmationtext="Tem certeza que deseja excluir esta lista?" :showDialog="showConfirmation" @confirm="confirmDeleteGiftlist()" @cancel="cancelDeleteGiftlist()" />
		
		<information informationtext="Arquivo importado com sucesso!" :showDialog="showInformation" @ok="showInformation=false" />

  </Layout>
</template>

<style>


.ext {
    text-align: center
}

.int {
    margin: 0 auto;
    text-align: left;
    position: relative;
    width: 1170px
}

.centered-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

